import React from 'react'
import Join from '../../pages/Join'
import ServiceFeature2 from '../services/ServiceFeature2'
import Locations from '../services/Locations'

const ServicesPage = () => {
  return (
    <>
    <Join />
    <ServiceFeature2 />
    <Locations />
    </>
  )
}

export default ServicesPage